export const colors ={
    success: '#1c9600',
    warning: '#ff7626',
    info: '#267ced',
}